import PropTypes from 'prop-types'
import Button from "./Button"
import { useLocation } from 'react-router-dom'

const Header = ({title, onAddd, showAdd}) => {
    const location = useLocation()
    
    return (
        <header className="header">
            <h1>{title}</h1>
            {location.pathname === '/' && <Button 
                color={!showAdd ? "blue" : "red"} 
                text={!showAdd ? "Add" : "Close"} 
                onClick={onAddd} 
            />}
        </header>
    )
}
Header.defaultProps = {
    title: "Task-Tracker"
}

Header.propTypes = {
    title: PropTypes.string.isRequired
}


export default Header
